import React from 'react';
import { Box, Typography, Grid, Card, CardContent, CardActionArea, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import UploadIcon from '@mui/icons-material/Upload';
import DataObjectIcon from '@mui/icons-material/DataObject';
import ErrorIcon from '@mui/icons-material/Error';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PeopleIcon from '@mui/icons-material/People';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useTranslation } from 'react-i18next';

const AdminPage = () => {
  const { t } = useTranslation();

  const adminItems = [
    {
      title: t('admin.items.uploads.title'),
      description: t('admin.items.uploads.description'),
      icon: <UploadIcon sx={{ fontSize: 40 }} />,
      path: '/uploads',
      color: '#1976d2'
    },
    {
      title: t('admin.items.rawActivityData.title'),
      description: t('admin.items.rawActivityData.description'),
      icon: <DataObjectIcon sx={{ fontSize: 40 }} />,
      path: '/activity-data/',
      color: '#388e3c'
    },
    {
      title: t('admin.items.dataFiles.title'),
      description: t('admin.items.dataFiles.description'),
      icon: <AssessmentIcon sx={{ fontSize: 40 }} />,
      path: '/data-files',
      color: '#7b1fa2'
    },
    {
      title: t('admin.items.processingErrors.title'),
      description: t('admin.items.processingErrors.description'),
      icon: <ErrorIcon sx={{ fontSize: 40 }} />,
      path: '/errors',
      color: '#c62828'
    },
    {
      title: t('admin.items.apiDocumentation.title'),
      description: t('admin.items.apiDocumentation.description'),
      icon: <DescriptionIcon sx={{ fontSize: 40 }} />,
      path: '/docs',
      external: true,
      color: '#455a64'
    },
    {
      title: t('admin.items.customers.title'),
      description: t('admin.items.customers.description'),
      icon: <PeopleIcon sx={{ fontSize: 40 }} />,
      path: '/customers',
      color: '#00695c'
    },
    {
      title: t('admin.items.deleteTimeslot.title'),
      description: t('admin.items.deleteTimeslot.description'),
      icon: <DeleteForeverIcon sx={{ fontSize: 40 }} />,
      path: '/timeslots/delete',
      color: '#ad1457'
    },
    {
      title: t('admin.items.apiReference.title'),
      description: t('admin.items.apiReference.description'),
      icon: <DescriptionIcon sx={{ fontSize: 40 }} />,
      path: '/redoc',
      external: true,
      color: '#37474f'
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
        <SettingsIcon sx={{ fontSize: 32, mr: 2, color: 'primary.main' }} />
        <Typography variant="h4" component="h1">
          {t('admin.title')}
        </Typography>
      </Box>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        {t('admin.subtitle')}
      </Typography>

      <Grid container spacing={3}>
        {adminItems.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.path}>
            <Card
              sx={{
                height: '100%',
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 4
                }
              }}
            >
              <CardActionArea
                component={item.external ? Link : RouterLink}
                to={item.external ? undefined : item.path}
                href={item.external ? item.path : undefined}
                target={item.external ? '_blank' : undefined}
                rel={item.external ? 'noopener noreferrer' : undefined}
                sx={{ height: '100%' }}
              >
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  <Box
                    sx={{
                      color: item.color,
                      mb: 2,
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography variant="h6" component="h2" gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdminPage;
